<template>
  <gateway :fts="fts" :lts="lts" :loc="loc" :closed="closed" :res_token="res_token"></gateway>
</template>


<script>
import reservation from '@comp/reservation'
import gateway from '@comp/gateway'
export default {
  name: "app",
  components: {
    gateway
  },
  data() {
    return {
      toJSON: null //devtool bug work around -_-
    }
  },
  computed: {
    fts() {
      return document.getElementById('app').getAttribute('fts')
    },
    lts() {
      return document.getElementById('app').getAttribute('lts')
    },
    loc() {
      return document.getElementById('app').getAttribute('loc')
    },
    closed() {
      return document.getElementById('app').getAttribute('closed')
    },
    res_token() {
      return document.getElementById('app').getAttribute('res_token')
    }
  }
}

</script>
